import BillingAddressResourceModel from '../../generated/types/model/resource/BillingAddressResourceModel';

export default class BillingAddressResourceViewModel extends BillingAddressResourceModel {
  constructor() { super(); this.isEqualToSchoolAddress = true; }
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
  get isOmContact():boolean { return this.dto.contactId !== undefined && this.dto.contactId !== null; }
}
